import React from 'react';
import { ReturnMethodType } from '@src/constants/general';

const CardMethodDescription = ({
  method,
}: {
  method: ReturnMethodType | 'Split';
}) => {
  const descriptions: { [key in ReturnMethodType | 'Split']: string } = {
    'In-Store': 'Bring all items to your nearest store.',
    UPS: 'Drop the item at a nearby UPS location.',
    LORP: "We'll pickup the item at your location.",
    Split: 'Choose a return method for each item.',
    SORIS: 'Bring all items to your nearest store.',
  };

  return <>{descriptions[method]}</>;
};

export default CardMethodDescription;
